export * from './TextAlignLeftIcon';
export * from './TextAlignLeftIcon16Light';
export * from './TextAlignLeftIcon16Regular';
export * from './TextAlignLeftIcon16Solid';
export * from './TextAlignLeftIcon20Light';
export * from './TextAlignLeftIcon20Regular';
export * from './TextAlignLeftIcon20Solid';
export * from './TextAlignLeftIcon24Regular';
export * from './TextAlignLeftIcon24Solid';
export * from './TextAlignLeftIcon32Regular';
export * from './TextAlignLeftIcon64Regular';
